import { useMemo } from "react";

const FeedShareCard = ({ preview }) => {
  const { filter_summary, source_count } = preview || {};
  const tags = useMemo(() => {
    const all = [];
    if (filter_summary?.target_types?.length)
      filter_summary.target_types.forEach((t) =>
        all.push({ label: t, kind: "type" }),
      );
    if (filter_summary?.domains?.length)
      filter_summary.domains.forEach((d) =>
        all.push({ label: d, kind: "domain" }),
      );
    if (filter_summary?.keywords?.length)
      filter_summary.keywords.forEach((k) =>
        all.push({ label: k, kind: "keyword" }),
      );
    return all;
  }, [filter_summary]);

  return (
    <div className="space-y-2">
      {tags.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {tags.map((tag, i) => (
            <span
              key={i}
              className="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-light bg-surface border border-surfaceBorder text-mutedText"
            >
              <span
                className="w-1.5 h-1.5 rounded-full mr-1.5 flex-shrink-0"
                style={{
                  backgroundColor:
                    tag.kind === "type"
                      ? "rgba(14,165,233,0.7)"
                      : tag.kind === "domain"
                        ? "rgba(168,85,247,0.7)"
                        : "rgba(234,179,8,0.7)",
                }}
              />
              {tag.label}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default FeedShareCard;
